const isDateNotInFuture = (inputDate: string) => {
	const [day, month, year] = inputDate.split('/').map(Number);

	if (isNaN(day) || day < 1 || day > 31) {
		return 'The day provided is invalid. Please enter a day between 1 and 31.';
	}

	if (isNaN(month) || month < 1 || month > 12) {
		return 'The month provided is invalid. Please enter a month between 1 and 12.';
	}

	if (isNaN(year) || year < 2000) {
		return 'The year provided is invalid. Please enter a year from 2000 onwards.';
	}

	const formattedDate = new Date(year, month - 1, day);

	if (
		formattedDate.getDate() !== day ||
		formattedDate.getMonth() !== month - 1 ||
		formattedDate.getFullYear() !== year
	) {
		return 'The date provided is invalid. Please check the day, month, and year values.';
	}

	const today = new Date();
	today.setHours(0, 0, 0, 0);

	return formattedDate <= today
		? ''
		: 'The date provided is in the future. Please enter a past or current date.';
};

export default isDateNotInFuture;
